import { INVENTORY_SOURCES, PRODUCTS } from '@/legacy/mocks/seed';
import { useStore } from '@/legacy/store';
import type { WarehouseServices } from '../warehouseContracts';

export const mockWarehouseServices: WarehouseServices = {
  async dashboard() {
    const s = useStore.getState();
    const pending = s.orders.filter((o) => ['processing', 'pending'].includes(o.status));
    const low = s.products.filter((p) => p.stock <= 10);
    return {
      name: 'Mumbai Hub',
      openPicks: pending.length,
      pendingTransfers: s.stockTransfers.filter((t) => t.status === 'draft' || t.status === 'submitted').length,
      locations: INVENTORY_SOURCES.length,
      lowStock: low.map((p) => ({ id: p.id, name: p.name, sku: p.sku, stock: p.stock })),
      awaiting: pending.slice(0, 20).map((o) => ({
        id: o.id, number: o.number, status: o.status, placedAt: o.createdAt, lines: o.items.length,
      })),
    };
  },
  async queue() {
    return useStore.getState().orders
      .filter((o) => ['pending', 'processing'].includes(o.status))
      .map((o) => ({
        id: o.id, number: o.number, fulfillmentStatus: o.fulfillmentStatus, customerName: o.customerName,
        shippingAddress: o.shippingAddress,
        items: o.items.map((it) => ({ id: it.id, name: it.productName, sku: it.sku, qty: it.qty })),
      }));
  },
  async advance() {},
  async transfers() {
    return useStore.getState().stockTransfers.map((t) => ({
      id: t.id,
      fromName: INVENTORY_SOURCES.find((s) => s.id === t.fromSourceId)?.name ?? t.fromSourceId,
      toName: INVENTORY_SOURCES.find((s) => s.id === t.toSourceId)?.name ?? t.toSourceId,
      itemCount: t.items.length,
      status: t.status === 'submitted' ? 'draft' : t.status,
      createdAt: t.createdAt,
    }));
  },
  async locations() {
    return INVENTORY_SOURCES.map((s) => ({ id: s.id, name: s.name }));
  },
  async createTransfer() {},
  async transferAction(id, status) {
    useStore.getState().updateStockTransferStatus(id, status as 'dispatched');
  },
  async stock() {
    return PRODUCTS.map((p) => ({ id: p.id, name: p.name, sku: p.sku, stock: p.stock }));
  },
  async recordCount() {},
};
